'use client';

import React from 'react';
import { ChevronLeft, ChevronRight, CalendarDays } from 'lucide-react';

interface Props {
  totalScheduled: number;
  currentMonth: Date;
  onMonthChange: (date: Date) => void;
}

const MONTH_NAMES_DE = [
  'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
  'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember',
];

export default function SchedulerHeader({ totalScheduled, currentMonth, onMonthChange }: Props) {
  const prevMonth = () => {
    const d = new Date(currentMonth);
    d.setMonth(d.getMonth() - 1);
    onMonthChange(d);
  };

  const nextMonth = () => {
    const d = new Date(currentMonth);
    d.setMonth(d.getMonth() + 1);
    onMonthChange(d);
  };

  return (
    <div className="flex items-center justify-between px-6 py-4 border-b border-border bg-black flex-shrink-0">
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 bg-accent/10 border border-accent/30 rounded flex items-center justify-center">
          <CalendarDays size={15} className="text-accent" />
        </div>
        <div>
          <p className="section-label">Scheduler</p>
          <h1 className="text-sm font-600 text-white mt-0.5">
            Content-Kalender · Veröffentlichungsplanung
          </h1>
        </div>
      </div>

      <div className="flex items-center gap-4">
        <div className="flex items-center gap-1 bg-surface border border-border rounded px-3 py-1.5">
          <span className="mono text-xs text-accent font-600">{totalScheduled}</span>
          <span className="text-xs text-muted ml-1">geplant</span>
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={prevMonth}
            className="btn-ghost py-1.5 px-2.5 text-xs"
            aria-label="Vorheriger Monat"
          >
            <ChevronLeft size={14} />
          </button>
          <span className="text-sm font-600 text-white min-w-[130px] text-center">
            {MONTH_NAMES_DE[currentMonth.getMonth()]} {currentMonth.getFullYear()}
          </span>
          <button
            onClick={nextMonth}
            className="btn-ghost py-1.5 px-2.5 text-xs"
            aria-label="Nächster Monat"
          >
            <ChevronRight size={14} />
          </button>
        </div>
      </div>
    </div>
  );
}
